/**
 * @generated SignedSource<<919b2a9c9785594a8cc9d47f0442ef08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionQueryDeployMutation$variables = {
  id: string;
};
export type processDefinitionQueryDeployMutation$data = {
  readonly deployProcessDefinition: boolean | null | undefined;
};
export type processDefinitionQueryDeployMutation = {
  response: processDefinitionQueryDeployMutation$data;
  variables: processDefinitionQueryDeployMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deployProcessDefinition",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQueryDeployMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQueryDeployMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a8291d15d04ff2a5fb1bde154692e78c",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQueryDeployMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionQueryDeployMutation(\n  $id: ID!\n) {\n  deployProcessDefinition(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "b381a676ea4bcdb875e8271011f7a064";

export default node;
